import React, { useEffect, useState, useRef,useLayoutEffect, useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';

// Components
import DateSelection from '../components/DateSelection';
import LeftComboGraph from '../components/LeftComboGraph';
import RightComboGraph from '../components/RightComboGraph';
import Table1 from '../components/Table1';
import NegNameTraineeScoreTable from '../components/NegNameTraineeScoreTable';
import TrainingProgTable from '../components/TrainingProgTable';
import CertificateCard from '../components/CertificateCard';

// Icons
import SessionIcon from '../assets/session-32x32.png';
import NegotiationIcon from '../assets/negotiation-32x32.png';

// API
import { verifyUser } from '../apis/admin.api';
import { getUnityModuleCount } from '../apis/user.api';
// import { fetchChapterDataApi } from '../apis/data.api';
// PROC
import { procLeadUnityData } from '../processes/fetchUserDataRtkQ';
// REDUX
import { setCurrentPage } from '../redux/app.slice';
import { useGetChaptersQuery, useGetUserDataQuery, useGetUserDataMultiRegionQuery } from '../apis/rtkData.api';
// import { getChapterGroupApi } from '../apis/data.api';
// COMPONENTS


const LeaderDash = () => {
  // console.log('LeaderDash RENDERING');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [userData, setUserData] = useState({});
  const [userLoggedIn, setUserLoggedIn] = useState(false); // eslint-disable-line
  const [loadTest, setLoadTest] = useState(false); // eslint-disable-line
  const [startDate, setStartDate] = useState(new Date('07/01/23'));
  const [endDate, setEndDate] = useState(new Date());
  const [maxModuleCount, setMaxModuleCount] = useState(0);
  const [table1Data, setTable1Data] = useState([]);
  const [negTableData, setNegTableData] = useState([]);
  // const [trainingProgData, setTrainingProgData] = useState([]);
  const [duration, setDuration] = useState(0);
  const [moduleCount, setModuleCount] = useState(0);
  // const [chapters, setChapters] = useState([]);
  // const [ chapterGroup, setChapterGroup ] = useState({});
  const [negotiationCount, setNegotiationCount] = useState(0);
  const [negotiationTime, setNegotiationTime] = useState(0);
  const { reactVerbosity } = useSelector((state) => state.app); // eslint-disable-line
  const { privacy } = useSelector((state) => state.app, shallowEqual); // eslint-disable-line
  const { user } = useSelector((state) => state.user, shallowEqual); // eslint-disable-line

  const [showFloatingButton, setShowFloatingButton] = useState(false);
  const [isTabsSticky, setIsTabsSticky] = useState(false);
  const contentRef = useRef(null);
  const tabsRef = useRef(null);

  const [activeTab, setActiveTab] = useState('Trainee Analytics');

  const [selectedDept, setSelectedDept] = useState({ value: 'all', label: 'All' });
  const [selectedTeam, setSelectedTeam] = useState({ value: 'all', label: 'All' });
  const [selectedRegion, setSelectedRegion] = useState({ value: 'all', label: 'All' });
  const [showDepartmentSelector, setShowDepartmentSelector] = useState(false);
  const [showTeamSelector, setShowTeamSelector] = useState(false);
  const [showRegionSelector, setShowRegionSelector] = useState(false);
  const [showResetSelectors, setShowResetSelectors] = useState(false);
  const [showCertificateCard, setShowCertificateCard] = useState(true);

  const [departmentOptions, setDepartmentOptions] = useState([
    { value: 'all', label: 'All' },
  ]);

  const [teamOptions, setTeamOptions] = useState([
    { value: 'all', label: 'All' },
  ]);

  const [regionOptions, setRegionOptions] = useState([
    { value: 'all', label: 'All' },
  ]);

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      color: 'black',
      width: '220px',
      borderRadius: '0.5rem', // rounded-lg
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)', // shadow-md
      '&:hover': {
        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)', // hover:shadow-lg
      },
      transition: 'box-shadow 200ms ease-in-out',
      minHeight: '38px',
      height: '38px',
      "@media only screen and (max-width: 850px)": {
        ...provided["@media only screen and (max-width: 1200px)"],
        width: "150px",
      },
      "@media only screen and (max-width: 790px)": {
        ...provided["@media only screen and (max-width: 1200px)"],
        width: "110px",
      },
      "@media only screen and (max-width: 650px)": {
        ...provided["@media only screen and (max-width: 1200px)"],
        width: "90px",
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: '38px',
      padding: '0 6px',
    }),
    input: (provided) => ({
      ...provided,
      margin: '0px',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: '38px',
    }),
  };

  
  const selection = {
    startDate,
    endDate
  };
  /* eslint-disable */
  // const {
  //   data: chData,
  //   error,
  //   isLoading: isLoadingChData,
  //   isSuccess,
  //   isError,
  //   isFetching
  // } = useGetChaptersQuery({
  //   authToken: user.idToken,
  //   user,
  //   selection
  // });
  // Org leaders see their org's usage aggregated across ALL regions by default via the
  // multi-region endpoint (a leader is scoped to their own org server-side). The original
  // single-region useGetUserDataQuery is kept in rtkData.api as a fallback.
  const {
    data: usrData,
    error: usrErr,
    isLoading: isLoadingUsrData,
    refetch: refetchUserData
  } = useGetUserDataMultiRegionQuery({
    authToken: user.idToken,
    user,
    selection
  });
  /* eslint-enable */
  
  useEffect(() => {
    dispatch(setCurrentPage('leaderDash'));
  }, []);

  // useEffect(() => {
  //   getChapterGroup();
  // }, [user]);

  // const getChapterGroup = async () => {
  //   const chGrp = await getChapterGroupApi(user.idToken, 'default');
  //   setChapterGroup(chGrp);
  // }

  useEffect(() => {
    window.addEventListener('popstate', (e) => {
      navigate('/', { replace: false });
    });
    return async () => {};
  }, []); // eslint-disable-line

  useEffect(() => {
    if (Object.keys(userData).length > 0) {
      reactVerbosity === 2 && console.log('+++++> USER DATA:', userData);
      buildDataForTable1();
      buildDataForNegTable();
      // buildDataForTrainingProgressTable();
    }
    reactVerbosity === 2 && console.log('DATES:', startDate, endDate);
  }, [userData && userData.sessionCount]); // eslint-disable-line

  useEffect(() => {
    if (!isLoadingUsrData) {
      fetchUserDataProcess();
    }
  }, [isLoadingUsrData, usrData]); // eslint-disable-line

  const fetchUserDataProcess = async () => {
    if (usrData == null) return;
    const maxModuleCount = await getUnityModuleCount();
    setMaxModuleCount(maxModuleCount.data);
    // const chapterData = await fetchChapterDataApi(user.idToken, user);
    const { userDataObj } = await procLeadUnityData(usrData, moduleCount);

    reactVerbosity === 2 && console.log('=======> fetchAdminUnityData:', userDataObj);
    setDuration(userDataObj.duration);
    setNegotiationCount(userDataObj.negotiations);
    setNegotiationTime(userDataObj.time);
    // setChapters(chapterData.data);
    setModuleCount(userDataObj.modules);
    setUserData(userDataObj);
  };

  const buildDataForTable1 = async () => {
    // console.log('+++++> USER DATA:', userData)
    const names = Object.keys(userData.moduleCountPerName);
    let maxSessions = 0;
    names.forEach((n) => {
      // console.log('userData.sessionCountObj[n]:', n, userData.sessionCountObj[n], parseInt(userData.sessionCountObj[n]))
      maxSessions = maxSessions + parseInt(userData.sessionCountObj[n]);
      // console.log('maxSessions:', maxSessions)
    })

    const tableData = names.map((n, id) => {
      let negotiations = 0;
      if (userData.negotiationsPerUser[n]) {
        negotiations = userData.negotiationsPerUser[n].length;
      }
      // console.log('Processing table1Data for:', n)
      return {
        name: n,
        region: (userData.regionPerName?.[n] || []).join(', '),
        modules: `${userData.moduleCountPerName[n]}/${maxModuleCount}`,
        sessions: userData.sessionsPerName[n].length,
        negotiations,
        negotiationTime: Math.round(userData.lengthsObj[n]) || 0,
        sessionCount: `${userData.sessionCountObj[n]}/${maxSessions}`,
      }
    })
    // console.log('======> TABLE1 tableData:', tableData)
    await setTable1Data(tableData);
    return tableData;
  };

  const buildDataForNegTable = async () => {
    // console.log('+++++> USER DATA:', userData)
    // console.log('(186) LEADER DASH PRIVACY, USER EMAIL:', privacy, user.email)
    const tableData =
      userData.sessions &&
      userData.sessions.map((s, index) => {
        // console.log("==========[> index, s:", index, s)
        return s.unitysessionmodules.map((m, i) => { // eslint-disable-line
          // console.log('==========[> i, m:', i,  m)
          if (
            m.moduleType === 'negotiation' &&
            m.userScore > 0 &&
            m.endTime - m.startTime > 0 &&
            (privacy > 0 || s.userId === user.email)
          ) {
            let date = new Date(s.sessionStartTime).toISOString().split('T')[0];
            const dateArr = date.split('-');
            date = dateArr[1] + '-' + dateArr[2] + '-' + dateArr[0];
            return {
              negotiation: m.moduleName,
              user: s.user.name,
              region: (s._region || '').toUpperCase(),
              userScore: m.userScore,
              maxScore: m.maxScore,
              date
            };
          }
        });
      });
    const arrFiltered = await filterNull(tableData);
    const flattened = arrFiltered.flat();
    const flattenedFiltered = flattened.filter((e) => !Array.isArray(e));
    setNegTableData(flattenedFiltered);
    reactVerbosity === 2 &&
      console.log('===> buildDataForNegTable flattenedFiltered DATA:', flattenedFiltered);
    return flattenedFiltered;
  };

  // const buildDataForTrainingProgressTable = async () => {
  //   // console.log('+++++> USER DATA:', userData)
  //   const lessons = {};
  //   const quizzes = {};
  //   const selfAssessments = {};

  //   const tableData =
  //     userData.sessions &&
  //     userData.sessions.map((s, index) => {
  //       // console.log('==========[> index, s:', index, s);
  //       if (s.userId === user.email) {

  //         return s.unitysessionmodules.map((m, i) => {  // eslint-disable-line
  //           // console.log('==========[> i, m:', i,  m)
  //           if (m.moduleType === 'lesson' && m.userScore !== -1 && m.userScore !== 0) {
  //             let date = new Date(s.sessionStartTime).toISOString().split('T')[0];
  //             const dateArr = date.split('-');
  //             date = dateArr[1] + '-' + dateArr[2] + '-' + dateArr[0];

  //             if (!lessons[s.user.name]) lessons[s.user.name] = {};
  //             if (!lessons[s.user.name][m.moduleName]) { lessons[s.user.name][m.moduleName] = {}; }
  //             lessons[s.user.name][m.moduleName] = {
  //               moduleType: 'Lesson',
  //               module: m.moduleName,
  //               user: s.user.name,
  //               userScore: m.userScore,
  //               complete: m.userScore === -1 ? 'X' : '\u2713',
  //               date
  //             };
  //           }
  //           if (m.moduleType === 'quiz' && m.userScore !== -1 && m.userScore !== 0) {
  //             let date = new Date(s.sessionStartTime).toISOString().split('T')[0];
  //             const dateArr = date.split('-');
  //             date = dateArr[1] + '-' + dateArr[2] + '-' + dateArr[0];

  //             if (!quizzes[s.user.name]) quizzes[s.user.name] = {};
  //             if (!quizzes[s.user.name][m.moduleName]) { quizzes[s.user.name][m.moduleName] = {}; }
  //             quizzes[s.user.name][m.moduleName] = {
  //               moduleType: 'Quiz',
  //               module: m.moduleName,
  //               user: s.user.name,
  //               userScore: m.userScore,
  //               complete: m.userScore === -1 ? 'X' : '\u2713',
  //               date
  //             };
  //           }

  //           if (m.moduleType === 'selfassessment' && m.userScore !== -1 && m.userScore !== 0) {
  //             let date = new Date(s.sessionStartTime).toISOString().split('T')[0];
  //             const dateArr = date.split('-');
  //             date = dateArr[1] + '-' + dateArr[2] + '-' + dateArr[0];
  
  //             if (!selfAssessments[s.user.name]) selfAssessments[s.user.name] = {};
  //             if (!selfAssessments[s.user.name][m.moduleName]) { selfAssessments[s.user.name][m.moduleName] = {}; }
  //             selfAssessments[s.user.name][m.moduleName] = {
  //               moduleType: 'Self Assessment',
  //               module: m.moduleName,
  //               user: s.user.name,
  //               userScore: m.userScore,
  //               complete: m.userScore === -1 ? 'X' : '\u2713',
  //               date
  //             };
  //             // console.log('--> buildDataForTrainingProgressTable selfAssessments:', selfAssessments)
  //           }
  //           if (Object.keys(lessons).length === 0) {
  //             lessons[s.user.name] = {};
  //           }
  //           if (Object.keys(quizzes).length === 0) {
  //             quizzes[s.user.name] = {};
  //           }
  //           if (Object.keys(selfAssessments).length === 0) {
  //             selfAssessments[s.user.name] = {};
  //           }

  //           if (m.moduleType !== 'negotiation') {
  //             let date = new Date(s.sessionStartTime).toISOString().split('T')[0];
  //             const dateArr = date.split('-');
  //             date = dateArr[1] + '-' + dateArr[2] + '-' + dateArr[0];
  //             return {
  //               moduleType: m.moduleType,
  //               module: m.moduleName,
  //               user: s.user.name,
  //               userScore: m.userScore,
  //               complete: m.userScore === -1 ? 'X' : '\u2713',
  //               date
  //             };
  //           };
  //         });
  //       } else {
  //         return [null];
  //       };
  //     });
  //   // console.log('=====> tableData:', tableData);
  //   const arrFiltered = await filterNull(tableData);
  //   const flattened = arrFiltered.flat();
  //   const flattenedFiltered = flattened.filter((e) => !Array.isArray(e));
  //   reactVerbosity === 2 && console.log(
  //       '=============> buildDataForTrainingProgressTable flattenedFiltered DATA:',
  //       flattenedFiltered
  //     );

  //   // console.log('==========> chapters:', chapters);
  //   let chapterLessons = [];
  //   let chapterQuizzes = [];
  //   let chapterSelfAssessments = [];

  //   chapters && chapters.forEach((c) => {

  //       c.lessons.forEach((l) => {
  //         chapterLessons = [
  //           ...chapterLessons,
  //           {
  //             chapter: c.title,
  //             chapterId: c._id,
  //             chapterIndex: c.chapterIndex,
  //             number: l.moduleIndex,
  //             moduleType: 'Lesson',
  //             module: l.moduleName,
  //             userScore: -1,
  //             complete: 'X',
  //             date: ''
  //           }
  //         ];
  //       });
        
  //       c.quizzes.forEach((q) => {
  //         chapterQuizzes = [
  //           ...chapterQuizzes,
  //           {
  //             chapter: c.title,
  //             chapterId: c._id,
  //             chapterIndex: c.chapterIndex,
  //             number: q.moduleIndex,
  //             moduleType: 'Quiz',
  //             module: q.moduleName,
  //             userScore: -1,
  //             complete: 'X',
  //             date: ''
  //           }
  //         ];
  //       });
  //       // console.log('====> c.selfassessments (350):', c.selfassessments)
  //       c.selfassessments && c.selfassessments.forEach((sa) => {
  //         // console.log('====> sa (352):', sa, chapterSelfAssessments)
  //         if (true) {
  //           chapterSelfAssessments = [
  //             ...chapterSelfAssessments,
  //             {
  //               chapter: c.title,
  //               chapterIndex: c.chapterIndex,
  //               chapterId: c._id,
  //               number: sa.moduleIndex,
  //               moduleType: 'Self Assessment',
  //               module: sa.moduleName,
  //               userScore: -1,
  //               complete: 'X',
  //               date: ''
  //             }
  //           ];
  //         } 
  //       });
  //       // console.log('====> chapterSelfAssessments (370):', chapterSelfAssessments)
  //     });

  //   const rebuiltTableData = [];

  //   const lessonKeys = Object.keys(lessons);
  //   lessonKeys.forEach((k) => {
  //     chapterLessons.forEach((l) => {
  //       l.user = k;
  //       if (!lessons[k][l.module]) {
  //         lessons[k][l.module] = { ...l };
  //       } else {
  //         lessons[k][l.module].chapter = l.chapter;
  //         lessons[k][l.module].number = l.moduleIndex;
  //       }
  //       rebuiltTableData.push(lessons[k][l.module]);
  //     });
  //   });
    
  //   const quizKeys = Object.keys(quizzes);
  //   quizKeys.forEach((k) => {
  //     chapterQuizzes.forEach((q) => {
  //       q.user = k;
  //       if (!quizzes[k][q.module]) {
  //         quizzes[k][q.module] = { ...q };
  //       } else {
  //         quizzes[k][q.module].chapter = q.chapter;
  //         quizzes[k][q.module].number = q.moduleIndex;
  //       }
  //       rebuiltTableData.push(quizzes[k][q.module]);
  //     });
  //   });

  //   const selfAssessmentKeys = Object.keys(selfAssessments);
  //   // console.log('----> selfAssessmentKeys (404):', selfAssessmentKeys)
  //   selfAssessmentKeys.forEach((k) => {
  //     chapterSelfAssessments.forEach((sa) => {
  //       sa.user = k;
  //       // console.log("====> sa.user, sa (408):", sa.user, sa)
  //       // console.log("======> selfAssessments[k] (409):", selfAssessments[k])
  //       if (!selfAssessments[k][sa.module]) {
  //         selfAssessments[k][sa.module] = { ...sa };
  //       } else {
  //         selfAssessments[k][sa.module].chapter = sa.chapter;
  //         selfAssessments[k][sa.module].number = sa.moduleIndex;
  //       }
  //       rebuiltTableData.push(selfAssessments[k][sa.module]);
  //     });
  //   });

  //   // console.log('=======> selfAssessments (446):', selfAssessments)
    

  //   reactVerbosity === 2 && console.log('===> rebuiltTableData (449):', rebuiltTableData);
  //   let chapterGroupObj = {};
  //   rebuiltTableData.forEach((m) => {
  //     // if (m.chapterId) {
  //       if (!chapterGroupObj[m.chapterIndex]) chapterGroupObj[m.chapterIndex] = [];
  //       chapterGroupObj[m.chapterIndex] = [...chapterGroupObj[m.chapterIndex], m];
  //     // }
  //   })
  //   // console.log('chapterGroupObj:', chapterGroupObj)
  //   const cgKeys = Object.keys(chapterGroupObj);

  //   let concatenatedTableData = [];
  //   cgKeys.map((k) => {
  //     return concatenatedTableData = [...concatenatedTableData, chapterGroupObj[k]]
  //   })
  //   // console.log('---> concatenatedTableData (469):', concatenatedTableData.flat())
  //   setTrainingProgData(concatenatedTableData.flat());
  //   return concatenatedTableData.flat();
  // };

  const filterNull = (tableData) => {
    return tableData.map((e) => {
      return e.map((m) => {
        if (m !== null && m !== undefined) {
          return m;
        }
        return [];
      });
    });
  };

  const setDefaultDates = async (start, end) => {
    await setStartDate(start);
    await setEndDate(end);
  };
  const handleStartDate = (date) => {
    setStartDate(date);
  };
  const handleEndDate = (date) => {
    setEndDate(date);
  };

  const handleDateChange = (start, end) => {
    setStartDate(start);
    setEndDate(end);
    // Add any additional logic you need when dates change
  };

  const handleFloatingButtonClick = () => {
    const adminDashElement = document.querySelector('.bg-gray-100');
    const scrollableParent = adminDashElement ? findScrollableParent(adminDashElement) : null;

    if (scrollableParent && scrollableParent !== document.documentElement && scrollableParent !== document.body) {
      scrollableParent.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const findScrollableParent = (element) => {
    if (!element) return null;
    if (element.scrollHeight > element.clientHeight) {
      return element;
    }
    return findScrollableParent(element.parentElement);
  };

  const handleSelectDepartment = (option) => {
    setSelectedDept(option);
    // Fetch and update team options based on selected department
  };

  const handleSelectTeam = (option) => {
    setSelectedTeam(option);
    // Update any necessary state or fetch data based on selected team
  };

  const handleSelectRegion = (option) => {
    setSelectedRegion(option);
    // Update any necessary state or fetch data based on selected region
  };

  const handleReset = () => {
    setSelectedDept({ value: 'all', label: 'All' });
    setSelectedTeam({ value: 'all', label: 'All' });
    setSelectedRegion({ value: 'all', label: 'All' });
    // Fetch data with reset filters
  };

  useEffect(() => {
    const handleScroll = () => {
      if (tabsRef.current) {
        const tabsTop = tabsRef.current.getBoundingClientRect().top;
        setIsTabsSticky(tabsTop <= 0);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useLayoutEffect(() => {
    // console.log('AdminDash component mounted');
    
    // Log the heights of various elements
    // console.log('Body scroll height:', document.body.scrollHeight);
    // console.log('Document element scroll height:', document.documentElement.scrollHeight);
    // console.log('Window inner height:', window.innerHeight);

    // Try to find the scrollable container
    const findScrollableParent = (element) => {
      if (!element) return null;
      if (element.scrollHeight > element.clientHeight) {
        // console.log('Potential scrollable element found:', element);
        return element;
      }
      return findScrollableParent(element.parentElement);
    };

    const adminDashElement = document.querySelector('.bg-gray-100'); // Adjust this selector if needed
    let scrollableParent = null;

    if (adminDashElement) {
      scrollableParent = findScrollableParent(adminDashElement);
      // console.log('Scrollable parent:', scrollableParent);
    } else {
      // console.log('AdminDash element not found');
    }

    // Attempt to log scroll events on both window and potential scrollable parent
    const handleScroll = (event) => {
      // console.log('Scroll event detected on:', event.target);
      // console.log('Scroll position:', event.target.scrollTop);
      
      // Update floating button visibility
      setShowFloatingButton(event.target.scrollTop > 100);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    if (scrollableParent) {
      scrollableParent.addEventListener('scroll', handleScroll, { passive: true });
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (scrollableParent) {
        scrollableParent.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  useLayoutEffect(() => {
    if (contentRef.current) {
      // console.log('Rendered content height:', contentRef.current.offsetHeight);
    }
  }, []);

  return (
    <div className="bg-gray-100 min-h-screen p-6 relative" ref={contentRef}>
      {/* Floating Arrow Up Button */}
      {showFloatingButton && (
        <button
          onClick={handleFloatingButtonClick}
          className="fixed bottom-8 left-8 bg-blue-500 hover:bg-blue-600 bg-opacity-70 hover:bg-opacity-100 text-white p-3 rounded-full shadow-lg transition duration-300 ease-in-out z-50 flex items-center justify-center"
          aria-label="Scroll to top"
        >
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            className="h-6 w-6" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M5 10l7-7m0 0l7 7m-7-7v18" 
            />
          </svg>
        </button>
      )}

      <div className="space-y-6">
        <header>
          <h1 className="text-3xl font-bold text-gray-800 mb-4">Insights</h1>
          <div className="flex flex-wrap items-end space-x-4 mb-4">
          <div className="flex-1 min-w-[200px] max-w-[250px]">
              <label htmlFor="date-selection" className="mb-1 text-sm font-medium text-gray-700">Date Range</label>
              <DateSelection
                id="date-selection"
                start={startDate}
                end={endDate}
                setDefaultDates={setDefaultDates}
                handleStartDate={handleStartDate}
                handleEndDate={handleEndDate}
                handleDateChange={handleDateChange}
              />
            </div>
            {showDepartmentSelector && (
              <div className="flex-1 min-w-[200px] max-w-[250px]">
                <label htmlFor="dept-select" className="mb-1 text-sm font-medium text-gray-700">Department</label>
                <Select
                  id="dept-select"
                  value={selectedDept}
                  options={departmentOptions}
                  onChange={(option) => handleSelectDepartment(option)}
                  styles={customStyles}
                />
              </div>
            )}
            {showTeamSelector && (
              <div className="flex-1 min-w-[200px] max-w-[250px]">
                <label htmlFor="team-select" className="mb-1 text-sm font-medium text-gray-700">Team</label>
                <Select
                  id="team-select"
                  value={selectedTeam}
                  options={teamOptions}
                  onChange={(option) => handleSelectTeam(option)}
                  styles={customStyles}
                />
              </div>
            )}
            {showRegionSelector && (
              <div className="flex-1 min-w-[200px] max-w-[250px]">
                <label htmlFor="region-select" className="mb-1 text-sm font-medium text-gray-700">Region</label>
                <Select
                  id="region-select"
                  value={selectedRegion}
                  options={regionOptions}
                  onChange={(option) => handleSelectRegion(option)}
                  styles={customStyles}
                />
              </div>
            )}
            {showResetSelectors && (<button
              onClick={handleReset}
              className="px-4 py-2 text-blue-600 hover:text-blue-800 transition-colors duration-200 underline self-end"
            >
              Reset
            </button>)}
          </div>
        </header>

        <div className="flex flex-col md:flex-row gap-6 h-[155px]">
          <div className="w-full md:w-[74%] flex flex-col md:flex-row gap-6">
            <div className="w-full md:w-1/2 bg-white rounded-lg shadow p-6">
              <div className="flex items-center mb-4">
                <img src={SessionIcon} alt="Session Icon" className="w-8 h-8 mr-3" />
                <h2 className="text-xl font-semibold">Session</h2>
              </div>
              <div className="flex justify-between">
                <div className="w-1/3">
                  <p className="text-sm text-gray-500">Amount</p>
                  <p className="text-3xl font-bold text-[#1F2937]">{userData.sessionCount || 0}</p>
                </div>
                <div className="w-1/3">
                  <p className="text-sm text-gray-500">Time (min)</p>
                  <p className="text-3xl font-bold text-[#1F2937]">{duration || 0}</p>
                </div>
                <div className="w-1/10"></div>
              </div>
            </div>
            <div className="w-full md:w-1/2 bg-white rounded-lg shadow p-6">
              <div className="flex items-center mb-4">
                <img src={NegotiationIcon} alt="Negotiation Icon" className="w-8 h-8 mr-3" />
                <h2 className="text-xl font-semibold">Negotiation</h2>
              </div>
              <div className="flex justify-between">
                <div className="w-1/3">
                  <p className="text-sm text-gray-500">Amount</p>
                  <p className="text-3xl font-bold text-[#1F2937]">{negotiationCount || 0}</p>
                </div>
                <div className="w-1/3">
                  <p className="text-sm text-gray-500">Time (min)</p>
                  <p className="text-3xl font-bold text-[#1F2937]">{((negotiationTime / 1000 / 60) || 0).toFixed(0)}</p>
                </div>
                <div className="w-1/10"></div>
              </div>
            </div>
          </div>
          {showCertificateCard && (<div className="w-full md:w-[26%]">
            <CertificateCard email={user.email} startDate={startDate} endDate={endDate} />
          </div>)}
        </div>

        <div className="bg-white rounded-lg shadow p-4">
          {userData.sessionsPerDate && userData.sessionTimePerDate && (
            <LeftComboGraph
              sessionsPerDate={[userData.sessionsPerDate]}
              sessionTimePerDate={userData.sessionTimePerDate}
              text={['Sessions vs. Date', 'Session Time vs. Date']}
              reactVerbosity={reactVerbosity}
            />
          )}
        </div>

        <div className="bg-white rounded-lg shadow p-4">
          {userData.negotiationTimePerDate && (
            <RightComboGraph
              negotiationTimePerDate={userData.negotiationTimePerDate}
              negotiationCountPerDate={userData.negotiationCountPerDate}
              reactVerbosity={reactVerbosity}
            />
          )}
        </div>

        <div 
          ref={tabsRef}
          className={`${isTabsSticky ? 'sticky top-0 z-10' : ''}`}
        >
          <nav className="flex space-x-4 mb-4" aria-label="Tabs">
            {['Trainee Analytics', 'Negotiation Scores'].map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`
                  px-3 py-2 text-sm font-medium rounded-md
                  ${activeTab === tab
                    ? 'bg-[#071146] text-white'
                    : 'text-blask-500 hover:bg-indigo-100'}
                  transition-colors duration-150 ease-in-out
                `}
              >
                {tab}
              </button>
            ))}
          </nav>

          <div>
            {activeTab === 'Trainee Analytics' && (
              <Table1
                data={table1Data}
                maxModuleCount={maxModuleCount}
              />
            )}

            {activeTab === 'Negotiation Scores' && (
              <NegNameTraineeScoreTable data={negTableData} />
            )}

          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaderDash;